import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Login from '../views/auth/Login.vue'
import Signup from '../views/auth/Signup.vue'
import CreateCharacter from '../views/CreateCharacter.vue'
import Character from '../views/Character.vue'
import Map from '../views/Map.vue'
import Zombie from '../views/Zombie.vue'
import Item from '../views/Item.vue'
import { projectAuth, projectFirestore } from '@/firebase/config'
import Storage from '../views/Storage.vue'
import Tattoo from '../views/Tattoo.vue'
import Hospital from '../views/Hospital.vue'
import EntertainmentComplex from '../views/EntertainmentComplex.vue'
import Shop from '../views/Shop.vue'
import ManagerRoom from '../views/ManagerRoom.vue'
import Criminal from '../views/Criminal.vue'
import Survivor from '../views/Survivor.vue'
import Story from '../views/Story.vue'
import HowToPlay from '../views/HowToPlay.vue'
import Account from '../views/Account.vue'
import CriminalList from '../views/CriminalList.vue'
import Log from '../views/Log.vue'
import LogAdmin from '../views/admin/Log.vue'
import SurvivalLeader from '../views/SurvivalLeader.vue'
import Topup from '../views/Topup.vue'
import TopupList from '../views/admin/TopupList.vue'
import Users from '../views/admin/Users.vue'
import UpgradeRoom from '../views/UpgradeRoom.vue'
import DailyStats from '../views/DailyStats.vue'
import Stats from '../views/Stats.vue'
import MysteriousStorage from '../views/MysteriousStorage.vue'
import Setting from '../views/Setting.vue'
import Notifications from '../views/Notifications.vue'
import Posts from '../views/Posts.vue'
import AdminCharacterView from '../views/admin/AdminCharacterView.vue';
import SurvivorCharacter from '../views/admin/SurvivorCharacter.vue';
import Craft from '../views/Craft.vue'

import ItemTransferHistory from '../views/ItemTransferHistory.vue'
import AssassinateSurvivor from '../views/AssassinateHistory.vue'
import CheckCharacter from '../views/CheckCharacter.vue'
import CheckStorageAndBag from '../views/CheckStorageAndBag.vue'
import BasementSetting from '../views/BasementSetting.vue'
import Ghost from '../views/Ghost.vue'
import GhostJar from '../views/GhostJar.vue'
import Merchant from '../views/Merchant.vue'
import ManageRobot from '../views/ManageRobot.vue'
import RaidBoss from '../views/RaidBoss.vue'
import Marketplace from '../views/Marketplace.vue'
import MarketplaceHistory from '../views/MarketplaceHistory.vue'
import Occupier from '../views/Occupier.vue'
import Villager from '../views/Villager.vue'
import Camp from '../views/Camp.vue'
import Outpost from '../views/Outpost.vue'
import OutpostSetting from '../views/OutpostSetting.vue'
import CheckCamp from '../views/CheckCamp.vue'
import AdminMigratePlayers from '../views/admin/AdminMigratePlayers.vue'
import AdminMigrateVerify from '../views/admin/AdminMigrateVerify.vue'
import Mutant from '../views/Mutant.vue'
import Gank from '../views/Gank.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/story',
    name: 'Story',
    component: Story
  },
  {
    path: '/howtoplay',
    name: 'HowToPlay',
    component: HowToPlay
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/create_character',
    name: 'CreateCharacter',
    component: CreateCharacter,
    meta: { requiresAuth: true }
  },
  {
    path: '/character',
    name: 'Character',
    component: Character,
    meta: { requiresAuth: true }
  },
  {
    path: '/ghost_jar',
    name: 'GhostJar',
    component: GhostJar,
    meta: { requiresAuth: true }
  },
  {
    path: '/map',
    name: 'Map',
    component: Map
  },
  {
    path: '/zombie',
    name: 'Zombie',
    component: Zombie
  },
  {
    path: '/item',
    name: 'Item',
    component: Item
  },
  {
    path: '/storage',
    name: 'Storage',
    component: Storage,
    meta: { requiresAuth: true }
  },
  {
    path: '/tattoo',
    name: 'Tattoo',
    component: Tattoo,
    meta: { requiresAuth: true }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: { requiresAuth: true }
  },
  {
    path: '/book_shop',
    name: 'BookShop',
    component: Shop,
    meta: { requiresAuth: true }
  },
  {
    path: '/manager_room',
    name: 'ManagerRoom',
    component: ManagerRoom,
    meta: { requiresAuth: true }
  },

  {
    path: '/survivor',
    name: 'Survivor',
    component: Survivor,
    meta: { requiresAuth: true }
  },
  {
    path: '/log',
    name: 'Log',
    component: Log,
    meta: { requiresAuth: true }
  },
  {
    path: '/criminal',
    name: 'Criminal',
    component: Criminal,
    meta: { requiresAuth: true }
  },
  {
    path: '/criminal_list',
    name: 'CriminalList',
    component: CriminalList
  },
  {
    path: '/admin/log',
    name: 'LogAdmin',
    component: LogAdmin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/rank',
    name: 'SurvivalLeader',
    component: SurvivalLeader,
    meta: { requiresAuth: true }
  },
  {
    path: '/occupier',
    name: 'Occupier',
    component: Occupier,
    meta: { requiresAuth: true }
  },
  {
    path: '/topup',
    name: 'Topup',
    component: Topup,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/topup_list',
    name: 'TopupList',
    component: TopupList,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/upgrade_room',
    name: 'UpgradeRoom',
    component: UpgradeRoom,
    meta: { requiresAuth: true }
  },
  {
    path: '/daily_stats',
    name: 'DailyStats',
    component: DailyStats,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/stats',
    name: 'Stats',
    component: Stats,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/mysterious_storage',
    name: 'MysteriousStorage',
    component: MysteriousStorage,
    meta: { requiresAuth: true }
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { requiresAuth: true }
  },
  {
    path: '/posts',
    name: 'Posts',
    component: Posts,
    meta: { requiresAuth: true }
  },
  {
    path: '/craft',
    name: 'Craft',
    component: Craft,
    meta: { requiresAuth: true }
  },
  {
    path: '/ghost',
    name: 'Ghost',
    component: Ghost,
    meta: { requiresAuth: true }
  },
  {
    path: '/mutant',
    name: 'Mutant',
    component: Mutant,
    meta: { requiresAuth: true }
  },
  {
    path: '/camp',
    name: 'Camp',
    component: Camp,
    meta: { requiresAuth: true }
  },
  {
    path: '/outpost',
    name: 'Outpost',
    component: Outpost,
    meta: { requiresAuth: true }
  },
  {
    path: '/outpost_setting',
    name: 'OutpostSetting',
    component: OutpostSetting,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/users/:userId/character',
    name: 'AdminCharacterView',
    component: AdminCharacterView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },{
    path: '/survivor_character',
    name: 'SurvivorCharacter',
    component: SurvivorCharacter,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/item_transfer_history',
    name: 'ItemTransferHistory',
    component: ItemTransferHistory,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/assassinate_history',
    name: 'AssassinateSurvivor',
    component: AssassinateSurvivor,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/check_character',
    name: 'CheckCharacter',
    component: CheckCharacter,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/check_camp',
    name: 'CheckCamp',
    component: CheckCamp,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/check_storage_and_bag',
    name: 'CheckStorageAndBag',
    component: CheckStorageAndBag,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
 {
    path: '/basement_setting',
    name: 'BasementSetting',
    component: BasementSetting,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/migrate-players',
    name: 'AdminMigratePlayers',
    component: AdminMigratePlayers,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/migrate/:userId',
    name: 'AdminMigrateVerify',
    component: AdminMigrateVerify,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/manage_robot',
    name: 'ManageRobot',
    component: ManageRobot,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
   {
    path: '/raidboss',
    name: 'RaidBoss',
    component: RaidBoss,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/merchant',
    name: 'Merchant',
    component: Merchant,
    meta: { requiresAuth: true }
  },
  {
    path: '/villager',
    name: 'Villager',
    component: Villager,
    meta: { requiresAuth: true }
  },
  {
    path: '/gank',
    name: 'Gank',
    component: Gank,
    meta: { requiresAuth: true }
  },
  {
    path: '/marketplace',
    name: 'Marketplace',
    component: Marketplace,
    meta: { requiresAuth: true }
  },
  {
    path: '/marketplace_history',
    name: 'MarketplaceHistory',
    component: MarketplaceHistory,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

  if (!requiresAuth && !requiresAdmin) {
    return next()
  }

  // รอสถานะผู้ใช้จาก Firebase Authentication
  const user = await new Promise(resolve => {
    const unsubscribe = projectAuth.onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    })
  })

  if (requiresAuth && !user) {
    console.log('User not authenticated, redirecting to home')
    return next('/')
  }

  // ตรวจสอบ characterCreated สำหรับหน้า create_character
  if (to.path === '/create_character') {
    try {
      const userDoc = await projectFirestore
        .collection('users')
        .doc(user.uid)
        .get()

      if (!userDoc.exists) {
        console.log('User document not found, redirecting to home')
        return next('/')
      }

      const userData = userDoc.data()
      if (userData.characterCreated) {
        console.log('User has already created a character, redirecting to home')
        return next('/')
      }
    } catch (error) {
      console.error('Error checking characterCreated status:', error)
      return next('/')
    }
  }

  if (requiresAdmin) {
    try {
      // ดึงข้อมูลผู้ใช้จาก Firestore
      const userDoc = await projectFirestore
        .collection('users')
        .doc(user.uid)
        .get()

      if (!userDoc.exists) {
        console.log('User document not found, redirecting to home')
        return next('/')
      }

      const userData = userDoc.data()
      if (!userData.admin) {
        console.log('User is not an admin, redirecting to home')
        return next('/')
      }
    } catch (error) {
      console.error('Error checking admin status:', error)
      return next('/')
    }
  }

  console.log('User authenticated:', user.uid)
  next()
})

export default router